<template>
  <van-popup v-model="show" get-container="#app" round>
    <div class="pop-outer">
      <div class="pop-header">
        归寝详情
        <div class="close-btn" @click="closePop">
          <van-icon name="cross" />
        </div>
      </div>
      <div class="info-row1">

        <div class="row1-img" v-if="popData.inOutPhotos || popData.avater"
          :style="{ backgroundImage: `url(${popData.inOutPhotos || popData.avater})` }"
          @click="previewImg(popData.inOutPhotos || popData.avater)">
        </div>
        <div class="row1-img" v-else :style="{ backgroundImage: `url(${require('./user.png')})` }">
        </div>
        <div class="row1-info">
          <div class="info_item">
            <span>姓名：</span>{{ popData.name }}
          </div>
          <div class="info_item">
            <span>性别：</span>{{ popData.gender == '' ? '无' : popData.gender == 1 ? '女' : '男' }}
          </div>
          <div class="info_item">
            <span>班级：</span>{{ popData.className }}
          </div>
          <div class="leave_cancel" v-if="judgeLeave()" @click="leaveCancel">请假作废</div>
          <div class="stay_cancel" v-if="judgeStay()" @click="stayCancel">留宿作废</div>
        </div>


      </div>
      <div class="info-row2">

        <div style="color: #E30808;position: relative;">


          <div style="display: flex;line-height: 1rem;margin-top: 0.8rem;"
            v-if="popData.leaveListVMS && popData.leaveListVMS.length">
            <!-- <div style="line-height: 2rem;">请假时段：</div> -->

            <div class="leave-list">
              <div class="leave-list_item_leave" v-for="date in popData.leaveListVMS">
                <!-- <img /> -->
                <div style="line-height: 2rem;" v-if="date.eventType !== 2">{{ date.eventType === 0 ? '请假离校：' :
    date.eventType === 1 ? '请假归寝：' : '' }}</div>
                <div style="line-height: 2rem;">{{ formatTime(date.beginDate, 'YY-MM-DD HH:mm') }}~{{
    formatTime(date.endDate, 'YY-MM-DD HH:mm') }}</div>

              </div>
            </div>
          </div>



          <!-- 留宿时段  -->
          <div style="display: flex;line-height: 1rem;margin-top: 0.601rem;"
            v-if="popData.accommodateListVMS && popData.accommodateListVMS.length">
            <div class="leave-list">
              <div class="leave-list_item_stay" v-for="date in popData.accommodateListVMS">
                <div style="line-height: 2rem;">留宿时段：</div>
                <div style="line-height: 2rem;">{{ formatTime(date.beginDate, 'YY-MM-DD HH:mm') }}~{{
    formatTime(date.endDate, 'YY-MM-DD HH:mm') }}</div>
              </div>
            </div>
          </div>
          <!-- 久进未出 久出未进  -->
          <template v-else>
            <template v-if="formInfo.continuedDay">
              <div class="inoutalarm"
                v-if="formInfo.tolayStatus == 0 || formInfo.tolayStatus == 2 || formInfo.tolayStatus == 5 || formInfo.tolayStatus == 8">
                <img  src="./jiujinweichu.png" alt="">
                <div class="inoutalarm_text">
                  久进未出<span style="font-weight: bold;margin: 0 .1202rem;">{{ formInfo.continuedDay }}</span>天
                </div>
              </div>
              <div class="inoutalarm"
                v-if="formInfo.tolayStatus == 1 || formInfo.tolayStatus == 3 || formInfo.tolayStatus == 6 || formInfo.tolayStatus == 7">
                <img  src="./jiujinweichu.png" alt="">
                <div class="inoutalarm_text">
                  久出未进<span style="font-weight: bold;margin: 0 .1202rem;">{{ formInfo.continuedDay }}</span>天
                </div>
              </div>
            </template>
          </template>


        </div>
        <div style="display: flex;margin-top: 0.601rem;line-height: 1.1418rem;">
          <div style="flex-shrink: 0;color: #999999;">识别地点：</div>
          <div>{{ popData.inOutLocation ? popData.inOutLocation : '暂无识别信息' }}</div>
        </div>
        <div style="display: flex;margin-top: 0.601rem;line-height: 1.1418rem;">
          <div style="flex-shrink: 0;color: #999999;">识别时间：</div>
          <div>{{ popData.inOutTime ? formatTime(popData.inOutTime, 'YYYY-MM-DD HH:mm:ss') : '暂无识别信息' }}</div>
        </div>
        <div class="dispose-history" v-if="historyList.length > 0">
          <div class="history-title">在寝处理记录</div>
          <div class="history-list">
            <div class="history-item" v-for="item in historyList">
              <div class="history-left">
                <div class="item-img">
                  <img src="./clock.png" />
                </div>
                <div class="item-line">
                  <div class="line-dashed"></div>
                </div>
              </div>
              <div class="history-right">
                <div class="item-time">
                  <span>{{ formatTime(item.signTime, 'HH:mm MM-DD') }}</span>
                  <span>{{ item.signUserName }}{{ item.signUserOrgName ? '-' + item.signUserOrgName : '' }}</span>
                </div>
                <div class="item-user">
                  <span>变更状态为{{ statusList[item.signStatus] }}</span>
                  <span v-if="item.reason" @click="(showReason = true), (reason = item.reason)"
                    style="color: #3775ffff;">查看原因</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pop-button">
        <!-- <div class="check-button" @click="check()">{{ popData.status == 0 || popData.status == 2 ? '离寝' : '归寝' }}补签</div> -->
        <div class="check-button" @click="disposeStatus()">在寝状态处理</div>
        <div class="check-button" @click="handleClickStay()">留宿处理</div>
        <div class="check-button" @click="handleClickLeave()">请假处理</div>
      </div>
      <div class="type-img">
        <img
          v-if="(formInfo.leaveListVMS && formInfo.leaveListVMS.length) || popData.status == 4 || popData.status == 10 || popData.status == 11"
          src="./dorm-absence.png" />
        <template v-else>
          <img v-if="popData.status == 0 || popData.status == 2 || popData.status == 5 || popData.status == 8"
            src="./dorm-in.png" />
          <img v-if="popData.status == 1 || popData.status == 3 || popData.status == 6 || popData.status == 7"
            src="./dorm-notin.png" />
        </template>
      </div>
    </div>
    <disposePop ref="disposePopRef" @confirm="closePop"></disposePop>
    <van-popup v-model="showReason" get-container="#app" round>
      <div class="pop-reason-outer">
        <div class="pop-header">
          处理原因
          <div class="close-btn" @click="showReason = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div style="margin-top: 1rem;">
          {{ reason }}
        </div>
      </div>
    </van-popup>
  </van-popup>
</template>

<script>
import moment from 'moment';
import { ImagePreview } from 'vant';
import disposePop from './disposePop.vue';
export default {
  components: {
    disposePop
  },
  data() {
    return {
      statusList: ['在寝', '不在寝', '晚归', '未归', '请假', '正常归寝', '正常离寝', '迟离', '未离', '误识别记录', '请假在寝', '请假离校', '', '假期留宿'],
      historyList: [],
      show: false,
      findDate: '',
      timeType: '',
      // 是否归寝信息
      formInfo: {},
      // 人员信息
      popData: {},
      showReason: false,
      reason: ''
    };
  },
  methods: {

    // 判断是否有请假待作废
    judgeLeave() {
      if (this.popData.leaveListVMS && this.popData.leaveListVMS.length > 0) {
        // 判断是否超时
        let endTime = this.popData.leaveListVMS[0].endDate;
        if (moment().isBefore(endTime)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    // 判断是否有留宿待作废
    judgeStay() {
      if (this.popData.accommodateListVMS && this.popData.accommodateListVMS.length > 0) {
        let endTime = this.popData.accommodateListVMS[0].endDate;
        // 判断是否超时
        if (moment().isBefore(endTime)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    // 请假作废弹窗
    leaveCancel() {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否作废请假？'
      }).then(() => {
        this.leaveCancelFn()
      }).catch(() => { })
    },
    // 留宿作废弹窗
    stayCancel() {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否作废留宿？'
      }).then(() => {
        this.stayCancelFn()
      }).catch(() => { })
    },

    // 留宿作废函数
    async stayCancelFn() {
      const { code, data, msg } = await this.$https.dormAccommodateCancel({
        userId: this.$store.state.userId,
        leaveIds: [this.popData.accommodateListVMS[0].id],
        cancelLeaveInfo: ''
      });
      if (code == 200) {
        this.$toast('操作完成');
        this.getDormDetail()
        this.$emit('confirm', 'refresh')
        return;
      } else {
        this.$toast(msg);
      }
    },
    // 请假作废函数
    async leaveCancelFn() {
      const { code, data, msg } = await this.$https.toVoidLeave({
        userId: this.$store.state.userId,
        leaveIds: [this.popData.leaveListVMS[0].id],
        cancelLeaveInfo: ''
      });

      if (code == 200) {
        this.$toast('操作完成');
        this.getDormDetail();
        this.$emit('confirm', 'refresh')
        return;
      } else {
        this.$toast(msg);
      }
    },

    // 获取归寝详情
    getDormDetail() {
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      this.axios
        .post(`student-consumer/api/dormitory/getDormDataByDateAndUserId`, {
          findDate: this.findDate,
          userId: this.formInfo.userId,
          dormOrganId: this.formInfo.dormOrganId,
          timeType: this.timeType
        })
        .then(res => {
          if (res.code == 200) {
            loading.clear();
            this.popData = res.data;
            this.historyList = res.data.busRestockSignRecordListVMS ? res.data.busRestockSignRecordListVMS : [];
          } else {
            this.$toast.fail({ getContainer: '#app', message: res.msg });
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },






    open(data, date, timeType) {
      this.show = true;
      this.findDate = date;
      this.formInfo = data;
      this.timeType = timeType;
      this.popData = {};
      this.historyList = [];
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });

      this.axios
        .post(`student-consumer/api/dormitory/getDormDataByDateAndUserId`, {
          findDate: this.findDate,
          userId: this.formInfo.userId,
          dormOrganId: this.formInfo.dormOrganId,
          timeType: this.timeType
        })
        .then(res => {
          if (res.code == 200) {
            loading.clear();
            this.popData = res.data;
            this.historyList = res.data.busRestockSignRecordListVMS ? res.data.busRestockSignRecordListVMS : [];
          } else {
            this.$toast.fail({ getContainer: '#app', message: res.msg });
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },
    closePop(e) {
      if (e == 'refresh') {
        this.$emit('refresh');
      }
      this.show = false;
      setTimeout(() => {
        this.popData = {};
      }, 500);
    },
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl]
      });
    },

    // 在寝状态处理
    disposeStatus() {
      this.$refs.disposePopRef.open({ findDate: this.findDate, userId: this.formInfo.userId, timeType: this.popData.timeType, status: this.popData.status, dormOrganId: this.formInfo.dormOrganId });
    },

    // 请假处理
    handleClickLeave() {
      console.log('this.formInfo', this.popData)
      this.$emit('leave')
    },


    // 留宿处理
    handleClickStay() {
      this.$emit('stay')
    },


    // check() {
    //   const loadingToast = this.$toast.loading({
    //     duration: 0,
    //     message: '补签中...',
    //     forbidClick: true,
    //     getContainer: '#app'
    //   });
    //   let singDate = '';
    //   let rightDate = moment().format('HH:mm:ss');
    //   singDate = `${this.findDate} ${rightDate}`;
    //   this.axios
    //     .post(`student-consumer/nonInductive/attendance/dormSignInPlatform`, {
    //       signDate: singDate,
    //       userId: this.formInfo.userId,
    //       direction: this.popData.status == 0 || this.popData.status == 2 ? 2 : 1
    //     })
    //     .then(res => {
    //       if (res.code == 200) {
    //         this.show = false;
    //         loadingToast.clear();
    //         this.$toast.success({ getContainer: '#app', message: '补签成功' });
    //         this.$emit('refresh');
    //       } else {
    //         this.$toast.fail({ getContainer: '#app', message: res.msg });
    //       }
    //     })
    //     .catch(e => {
    //       this.$toast.fail({ getContainer: '#app', message: e.msg });
    //     });
    // },
    formatTime(time, format) {
      if (time) {
        return moment(time).format(format);
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('./loading.scss');

.pop-reason-outer {
  color: #333;
  padding: 0 1.5rem 1.5rem 1.5rem;
  width: 90vw;
  position: relative;
  font-size: 0.875rem;
  background: url('./popinfo-bg.png');
  background-size: 100% 100%;

  .pop-header {
    padding: 1rem 0 0.7rem 0;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: bold;

    .close-btn {
      position: absolute;
      color: #999999;
      right: -0.5rem;
      top: 1rem;
      font-size: 1rem;
    }
  }
}

.pop-outer {
  color: #333;
  padding: 0 1.2019rem;
  padding-bottom: 1.2019rem;
  width: 90vw;
  position: relative;
  font-size: 0.875rem;
  background: url('./popinfo-bg.png');
  background-size: 100% 100%;


  .info-row1 {
    display: flex;

    .row1-img {
      width: 5.3486rem;
      flex-shrink: 0; // 防止挤压导致尺寸变形
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: center center;

      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }

    .row1-info {
      padding-left: 3vw;
      // line-height: 2rem;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 0.875rem;
      color: #666666;
      line-height: 1.1418rem;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .info_item {
        margin-bottom: .601rem;

        &:nth-child(3n) {
          margin-bottom: 0;
        }

        span {
          color: #999999;
        }
      }

      // 请假作废
      .leave_cancel {
        margin-top: .601rem;
        margin-right: .601rem;
        padding: .2404rem .601rem;
        position: relative;
        display: inline-block;
        z-index: 10;
        background: #F1C229;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: .8413rem;
        color: #FFFFFF;
        line-height: 1.1418rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        border-radius: .9615rem;
      }

      // 留宿作废
      .stay_cancel {
        margin-top: .601rem;
        padding: .2404rem .601rem;
        background: #F5A20C;
        position: relative;
        z-index: 10;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: .8413rem;
        display: inline-block;
        color: #FFFFFF;
        line-height: 1.1418rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        border-radius: .9615rem;
      }
    }
  }

  .info-row2 {
    // margin-top: 0.5rem;
    line-height: 1.6rem;

    &>* {
      // margin-top: 1rem;
    }
  }

  .pop-button {
    margin-top: 1rem;
    text-align: center;
    display: flex;
    // background-color: red;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    .check-button {
      background-color: #1989fa;
      // border: 1px solid #1989fa;
      // display: inline-block;
      color: #fff;
      // flex: 1;
      width: 31.5%;
      padding: .4207rem 0;
      border-radius: .9615rem;
    }
  }

  .pop-header {
    padding: 1rem 0 0.7rem 0;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: bold;

    .close-btn {
      position: absolute;
      color: #999999;
      right: -0.5rem;
      top: 1rem;
      font-size: 1rem;
    }
  }

  .type-img {
    width: 6.5rem;
    height: 6.5rem;
    position: absolute;
    right: 0;
    top: 2.5rem;

    img {
      height: 100%;
      width: 100%;
    }
  }
}

.leave-list {
  flex: 1;
  max-height: 8rem;
  overflow: auto;
  display: flex;

  .leave-list_item_leave {
    display: flex;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: .8413rem;
    background-color: rgba(241, 194, 41, 0.08);
    color: #F1C229;
    text-align: left;
    border-radius: .2404rem;
    font-style: normal;
    text-transform: none;
  }

  .leave-list_item_stay {
    display: flex;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: .8413rem;
    background-color: rgba(245, 162, 12, 0.08);
    color: #F5A20C;
    text-align: left;
    font-style: normal;
    border-radius: .2404rem;
    text-transform: none;
  }

  &>div:not(:first-child) {
    padding-top: 0.5rem;
  }
}

// 久进未出久出未进 
.inoutalarm {
  display: flex;
  position: relative;
  img {
    width: 2.0433rem;
    height: 2.0433rem;
  }
  .inoutalarm_text {
    font-size: .8413rem;
    line-height: 1.3822rem;
    color: #E30808;
    height: 1.3822rem;
    align-items: flex-start;
    background-color: rgba(227, 8, 8, 0.06);
    border-radius: 0px .2404rem .2404rem 0px;
    position: absolute;
    bottom: 0;
    left: .9615rem;
    padding: 0 .3606rem 0 .9014rem;
  }
}


.dispose-history {
  .history-title {
    position: relative;
    // font-size:1rem;
    // padding: 0.1rem 0.1rem 0.1rem 0.8rem;
    padding-left: 0.8rem;
    margin-bottom: 0.5rem;
    margin-top: 0.601rem;

    &::before {
      display: block;
      content: '';
      width: 0.3rem;
      height: 60%;
      background-color: #3775ffff;
      position: absolute;
      border-radius: 0.15rem;
      left: 0;
      top: 20%;
    }
  }

  .history-list {
    max-height: 9rem;
    overflow: auto;
    padding-right: 1rem;

    .history-item {
      display: flex;

      .history-left {
        width: 1rem;

        .item-img {
          line-height: 1rem;
          height: 1rem;
          width: 1rem;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .item-line {
          width: 1rem;
          height: 2rem;
          display: flex;
          justify-content: center;

          .line-dashed {
            width: 1px;
            height: 2rem;
            border-left: 1px dashed #3775ffff;
          }
        }
      }

      .history-right {
        flex: 1;
        padding-left: 0.5rem;

        .item-time {
          font-size: 0.875rem;
          line-height: 1rem;
          display: flex;
          justify-content: space-between;
        }

        .item-user {
          color: #666666ff;
          font-size: 0.8rem;
          line-height: 2rem;
          display: flex;
          justify-content: space-between;
        }
      }
    }

    .history-item:last-child {
      .line-dashed {
        display: none;
      }
    }
  }
}
</style>
